






















import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {SelectOption} from "@/util/selectOption";

@Component
export default class IncomeSourcesChart extends Vue {

    @Prop()
    availableYears!: number[];

    private yearOptions: SelectOption[] = this.availableYears.map(year => {
        return {
            name: `${year} - ${year+1}`,
            id: year
        }
    });

    private yearOption: SelectOption = this.yearOptions[0];

    private dataEndpoint: string = '/reports/chart/income-sources';

    @Watch('yearOption')
    private onYearOptionChanged(newOption: SelectOption) {
        this.dataEndpoint = `/reports/chart/income-sources?year=${newOption.id}`;
    }
}
